<div
  class="hierarchy dropdown is-full-width"
  [ngClass]="{ 'is-active': isOpen }"
  (portalClickOutside)="onClickOutside()"
>
  <div class="select is-full-width">
    <div *ngIf="!organizationGroup">
      <input type="hidden" [formControl]="controlEntityUid" />
      <input
        #orgSingleInput
        type="text"
        class="input pr-5"
        readonly="true"
        [ngClass]="{ 'is-danger': isInvalid(controlEntityUid) }"
        [attr.id]="id"
        [formControl]="controlEntityName"
        placeholder="- Select -"
        (click)="onToggleDropdown($event)"
        (keydown.enter)="onToggleDropdown($event)"
        (keydown.space)="onToggleDropdown($event)"
        i18n-placeholder
      />
    </div>

    <div *ngIf="organizationGroup">
      <input type="hidden" [formControl]="controlEntityUid" />
      <div
        #orgGroupInput
        [ngClass]="{ 'is-danger': isInvalid(controlEntityUid) }"
        class="selected-entities pr-5"
        readonly="true"
        [attr.id]="id"
        (click)="onToggleDropdown($event)"
        (keydown.enter)="onToggleDropdown($event)"
        (keydown.space)="onToggleDropdown($event)"
        tabindex="0"
      >
        <div class="selectedFeature-list" *ngIf="selectedEntities?.name">
          <button
            type="button"
            class="button has-background-info-lighter has-text-dark has-not-border"
            title="{{ selectedEntities?.name }}"
          >
            <span>{{ selectedEntities?.name }}</span>
            <span
              class="icon is-size-7"
              (click)="removeSelectedParentOrg(selectedEntities?.entityUid)"
            >
              <i class="fas fa-times"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="dropdown-menu" [ngClass]="{ 'mt-4': organizationGroup && selectedEntities?.name }">
    <div class="dropdown-content">
      <div class="dropdown-item">
        <div class="field is-grouped is-flex-wrap-wrap">
          <div class="control mr-3 my-1" *ngFor="let searchParameter of searchParameterList">
            <label
              class="radio"
              attr.data-e2e="radio-search-parameter-label-{{ searchParameter.id }}"
            >
              <input
                [value]="searchParameter.id"
                [(ngModel)]="searchParameterType"
                type="radio"
                attr.data-e2e="radio-search-parameter-{{ searchParameter.id }}"
              />
              <span>{{ searchParameter.text }}</span>
            </label>
          </div>
        </div>
      </div>

      <hr class="dropdown-divider" />
      <div class="dropdown-item">
        <portal-search-filter-autocomplete-input
          [placeholder]="searchPlaceholder"
          [searchInputValue]="searchedText"
          [direction]="Directions.RIGHT"
          (search)="onSearch($event)"
        ></portal-search-filter-autocomplete-input>
      </div>

      <hr class="dropdown-divider" />

      <div class="dropdown-item has-text-truncate" *ngIf="loading$ | async">
        <span class="has-text-truncate">
          <portal-spinner
            [isHorizontal]="true"
            [isSmall]="true"
            text="Loading organisations..."
            i18n-text
          ></portal-spinner>
        </span>
      </div>

      <div
        class="dropdown-item"
        *ngIf="!(loading$ | async)"
        #scrollContainer
        (scroll)="onScrolled($event)"
      >
        <span class="is-word-wrap" *ngIf="!entities?.length" i18n>
          Start typing to search for organisations..
        </span>

        <!-- tree -->
        <tree-root
          #tree
          class="tree"
          [options]="options"
          [nodes]="entities"
          [(state)]="treeState"
          (toggleExpanded)="onToggleExpanded($event)"
          (activate)="onActivateItem($event.node.data)"
          (deactivate)="onDeactivateItem()"
          (focusin)="onFocusIn($event, tree.treeModel)"
          (focusout)="onFocusOut($event, tree.treeModel)"
        >
          <ng-template #treeNodeWrapperTemplate let-node let-index="index">
            <div
              class="is-align-items-start node-wrapper"
              [style.padding-left]="node.getNodePadding()"
            >
              <tree-node-expander
                *ngIf="node.hasChildren"
                role="button"
                tabindex="0"
                aria-label="Toggle node"
                class="is-align-content-baseline"
                (keydown.enter)="node.toggleExpanded(); $event.preventDefault()"
                (keydown.space)="node.toggleExpanded(); $event.preventDefault()"
                (keydown.arrowRight)="node.expand()"
                (keydown.arrowLeft)="node.collapse()"
                [node]="node"
              ></tree-node-expander>
              <div
                class="node-content-wrapper width-full"
                [ngClass]="{ 'disabled-node-text': isNodeDisabled(node) }"
                (click)="node.mouseAction('click', $event)"
                (dblclick)="node.mouseAction('dblClick', $event)"
                (contextmenu)="node.mouseAction('contextMenu', $event)"
                (treeDrop)="node.onDrop($event)"
                [treeAllowDrop]="node.allowDrop"
                [treeDrag]="node"
                [treeDragEnabled]="node.allowDrag()"
                role="treeitem"
                [attr.aria-label]="node.data?.name"
                tabindex="0"
                (keydown.enter)="node.toggleActivated(); $event.preventDefault()"
                (keydown.space)="node.toggleActivated(); $event.preventDefault()"
                [class.node-content-wrapper-active]="isNodeDisabled(node) ? false : node.isActive"
                [class.node-content-wrapper-focused]="isNodeDisabled(node) ? false : node.isFocused"
              >
                <div class="is-flex is-flex-direction-row is-justify-content-space-between">
                  <div class="is-flex is-flex-direction-column is-word-wrap">
                    <div>
                      <tree-node-content [node]="node" [index]="index"></tree-node-content>
                      <span class="node-count" *ngIf="node.data?.count">
                        ({{ node.data.count }})
                      </span>
                    </div>
                    <div
                      class="white-space-no-wrap my-1"
                      *ngIf="isEntityTypeVisible(node, isDeviceMobile$ | async)"
                    >
                      <span
                        class="tag"
                        [ngClass]="node.level === 1 ? 'is-special' : 'is-actionable'"
                      >
                        {{ node.data?.entityType | readableEntityType }}
                      </span>
                    </div>
                    <span
                      class="is-size-7 has-text-weight-normal"
                      *ngIf="isFriendlyNameFeatureActive && node.data?.friendlyName"
                    >
                      {{ node.data.friendlyName }}
                    </span>
                    <div>
                      <span
                        class="is-size-7 text-ellipsis"
                        *ngIf="node.data?.path"
                        [attr.title]="node.data.path"
                      >
                        {{ node.data.path | middleEllipsisPath }}</span
                      >
                    </div>
                  </div>
                  <div
                    class="white-space-no-wrap mt-0_5"
                    *ngIf="isEntityTypeVisible(node, !(isDeviceMobile$ | async))"
                  >
                    <span
                      class="tag"
                      [ngClass]="node.level === 1 ? 'is-special' : 'is-actionable'"
                      >{{ node.data?.entityType | readableEntityType }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template #treeNodeFullTemplate let-node let-index="index" let-templates="templates">
            <div
              [class]="node.getClass()"
              [class.tree-node]="true"
              [class.tree-node-expanded]="node.isExpanded && node.hasChildren"
              [class.tree-node-collapsed]="node.isCollapsed && node.hasChildren"
              [class.tree-node-leaf]="node.isLeaf"
              [class.tree-node-active]="node.isActive"
              [class.tree-node-focused]="node.isFocused"
              [class.is-tree-filtered]="hasFilteredText"
            >
              <tree-node-drop-slot
                *ngIf="index === 0"
                [dropIndex]="node.index"
                [node]="node.parent"
              >
              </tree-node-drop-slot>

              <tree-node-wrapper
                [node]="node"
                [index]="index"
                [templates]="templates"
              ></tree-node-wrapper>

              <tree-node-children [node]="node" [templates]="templates"></tree-node-children>

              <div
                class="load-more"
                *ngIf="
                  node.isExpanded && node?.children && node?.children?.length < node?.data?.count
                "
              >
                <button
                  *ngIf="!(loadingMore$ | async) && node?.data?.entityUid !== currentRootEntityId; else loadingTemplateForMore"
                  class="button has-text-primary is-text pl-5"
                  (click)="onLoadMore(node)"
                  i18n
                  (keydown.enter)="onLoadMore(node); $event.preventDefault()"
                  (keydown.space)="onLoadMore(node); $event.preventDefault()"
                >
                  Load more...
                </button>
                <ng-template #loadingTemplateForMore>
                  <ng-container *ngIf="(loadingMore$ | async) === node.id">
                    <div class="load-more-container">
                      <div class="spinner-container">
                        <div class="spinner" role="status" aria-live="assertive"></div>
                      </div>
                      <span i18n> Loading... </span>
                    </div>
                  </ng-container>
                </ng-template>
              </div>

              <tree-node-drop-slot
                [dropIndex]="node.index + 1"
                [node]="node.parent"
              ></tree-node-drop-slot>
            </div>
          </ng-template>

          <ng-template #treeNodeTemplate let-node let-index="index">
            <div class="is-flex is-flex-direction-column">
              <div>
                <span class="is-size-6 is-inline-block">{{ node.data?.name }}</span>
                <span class="has-text-grey" *ngIf="node.data?.count">
                  ({{ node.data?.count }})
                </span>
                <span class="is-size-6 ml-4" *ngIf="node.data?.trashCan">
                  <i class="fa fa-trash"></i>
                </span>
              </div>
              <span class="is-size-7" *ngIf="node.data?.path && !node.data?.trashCan">{{
                node.data?.path
              }}</span>
            </div>
          </ng-template>
        </tree-root>
        <span class="has-text-truncate" *ngIf="loadingNewPortion$ | async">
          <portal-spinner
            [isHorizontal]="true"
            [isSmall]="true"
            text="Loading organisations..."
            i18n-text
          ></portal-spinner>
        </span>
      </div>

      <hr class="dropdown-divider" />
      <div class="dropdown-item">
        <div
          class="buttons is-flex is-justify-content-space-between"
          *ngIf="displayOptionApplyAndClear"
        >
          <button
            class="button is-text has-text-primary"
            (click)="onClear()"
            (keydown.enter)="onClear()"
            type="button"
            i18n
            title="Clear"
            i18n-title
          >
            Clear
          </button>
          <button
            class="button is-primary"
            (click)="onFilterApplied(true)"
            (keydown.enter)="onFilterApplied(true)"
            type="button"
            i18n
            title="Apply"
            i18n-title
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
